import {
  getColorFromString,
  IButtonStyles,
  IStyle,
  ITheme,
  updateA
} from "@bps/fluent-ui";

const getOpacityColor = (theme: ITheme, opacity: number) =>
  updateA(getColorFromString(theme.palette.neutralLight)!, opacity).str;

export const navBarSplitButtonStyle = (
  theme: ITheme,
  isCurrent?: boolean
): IStyle => {
  const opacity0 = getOpacityColor(theme, 0);

  const opacity25 = getOpacityColor(theme, 25);
  const opacity50 = getOpacityColor(theme, 40);

  const buttonStyles = {
    background: isCurrent ? opacity25 : "inherit",
    "&:hover, &:active": {
      background: isCurrent ? opacity50 : opacity25
    }
  };

  return {
    wrapper: {
      display: "block",
      background: "inherit",
      "&:hover, &:active": { background: opacity0 }
    },
    contextMenuButtonRoot: buttonStyles,
    root: buttonStyles
  };
};

export const navBarActionButtonStyles = (
  theme: ITheme,
  isCurrent?: boolean,
  collapse?: boolean
): Partial<IButtonStyles> => {
  const style: IStyle = { color: theme.palette.white };

  return {
    textContainer: !!collapse && {
      ["@media (max-width: 700px)"]: {
        display: "none"
      }
    },
    icon: style,
    menuIcon: style,
    iconHovered: style,
    iconPressed: style,
    root: { background: isCurrent ? getOpacityColor(theme, 25) : "inherit" }
  };
};
